import { Route, Routes } from 'react-router-dom';
import { DictionaryPreload } from './dictionary';
import {
  AccountPage,
  DashboardRootPage,
  GamePage,
  GamesPage,
  JoinGamePage,
  LandingPage,
  NewGamePage,
  NotFoundPage,
  PlaceholderPage,
} from './pages';
import { ROUTES } from './routes';
import { WelcomeGate } from './session';

/**
 * Every route is public. /profile and /settings are the account area's tabs, and show guests a prompt to sign in.
 * /join/:code asks a guest to sign in and comes back; /games, /games/new and /games/:id send a guest to /welcome.
 */
function Application() {
  return (
    <Routes>
      <Route path={ROUTES.dashboard} element={<DashboardRootPage />} />
      <Route
        path={ROUTES.welcome}
        element={
          <WelcomeGate>
            <LandingPage />
          </WelcomeGate>
        }
      />
      {/* Placeholders until their screens land: guest mode ENG-826, daily ENG-827. They fetch the dictionary already. */}
      <Route
        path={ROUTES.play}
        element={
          <DictionaryPreload>
            <PlaceholderPage title="Play as a guest" />
          </DictionaryPreload>
        }
      />
      <Route
        path={ROUTES.daily}
        element={
          <DictionaryPreload>
            <PlaceholderPage title="Today's daily" />
          </DictionaryPreload>
        }
      />
      <Route path={ROUTES.profile} element={<AccountPage tab="profile" />} />
      <Route path={ROUTES.settings} element={<AccountPage tab="settings" />} />
      <Route path={ROUTES.games} element={<GamesPage />} />
      <Route path={ROUTES.newGame} element={<NewGamePage />} />
      <Route path={ROUTES.game} element={<GamePage />} />
      <Route path={ROUTES.join} element={<JoinGamePage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default Application;
